import React from "react";
import { ReactComponent as ScissorsIcon } from "../../../../assets/images/scissors-fill.svg";
import styles from "./AudioEditorTrackMixer.module.css";

const AudioEditorTrackSplitLine: React.FC = () => {
    return (
        <div id="cursor-follow-line" className={styles.splitLine}>
            <div className={styles.splitHandle}>
                <ScissorsIcon className={styles.splitScissors} />
            </div>
        </div>
    );
};

export default AudioEditorTrackSplitLine;
